'use client';

import { c as _c } from "react/compiler-runtime";
import { AdminBar } from '@/components/AdminBar';
import RichText from '@/components/RichText';
import { type Header } from '@/types';
import Image from 'next/image';
import Link from 'next/link';
export const NavTitle = t0 => {
  const $ = _c(6);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute -right-7 z-10"><AdminBar /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src="/logo.svg" width={25} height={36} alt="Logo" priority={true} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== data) {
    t3 = data?.title ? <RichText data={data.title} /> : "Tallinn Arvudes";
    $[2] = data;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="relative">{t1}<Link href="/" className="flex items-center gap-4 relative">{t2}<span className="text-nowrap text-xl md:text-3xl text-neutral-0 font-sans">{t3}</span></Link></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};